import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({ name: "zakaznik", kodKey: "nazev" });
